// return movements 'Scommesse' as TabListMovements 3'.
export const getBetsEndpoint = '/movimenti-conto-ms/ms/account/tickets/getBets';
